
import { IAppModule } from "./appmodules";
import ngRoute = angular.route;
import { versionSelector } from "./shared/nutrition/version/selector";
import { OmniaConfig } from "./types";

export function setupRoutes($routeProvider: ngRoute.IRouteProvider, modules: IAppModule[], { production }: OmniaConfig): void {

    const nutritionV1Url = production
        ? "/dha48ikolg/:view?/:action?/:id?"
        : "/nutrition/v1/:view?/:action?/:id?"

    $routeProvider.when("/dashboard", {
        template: "<omnia-dashboard></omnia-dashboard>"
    });

    $routeProvider.when("/fields/:action?/:id?", {
        template: "<omnia-fields></omnia-fields>"
    });

    $routeProvider.when("/datalayers/:action?/:id?", {
        template: "<omnia-datalayers></omnia-datalayers>"
    });

    $routeProvider.when("/stocks/v1", {
        template: "<omnia-stocks></omnia-stocks>"
    });

    $routeProvider.when("/seeds/:component?/:id?", {
        template: "<omnia-seeds></omnia-seeds>"
    });

    $routeProvider.when("/soil", {
        template: "<omnia-soil></omnia-soil>"
    });

    $routeProvider.when(nutritionV1Url, {
        template: "<omnia-nutri></omnia-nutri>"
    });

    modules.forEach(m => {
        $routeProvider.when(m.path, {

            template: m.template,

            resolve: m.loader
                ? {
                    omniaModule: ["$q", ($q: ng.IQService) => m.loader($q)]
                }
                : undefined,

        })
    });

    $routeProvider.when("/sync", {
        template: "<omnia-sync></omnia-sync>"
    });

    $routeProvider.otherwise({
        redirectTo: "/dashboard"
    });

    $routeProvider.when("/nutrition/:view?/:action?/:id?", versionSelector);

}
